"use strict";
/**
 * JS
 */
//common
import common from "./modules/common";
import { productSwiper, productSingleImageZoom } from "./modules/my-swiper";
jQuery(function ($) {
  $(function () {
    common();
    productSwiper();
    productSingleImageZoom()
  });
});

/**
 * CSS
 */
// import styles bundle
import "../scss/single_product.scss";
